<template>
	<div class="buttons">
		<button v-t="'action.buildImport'" class="button is-dark" @click="showImport(true)" />
		<button v-t="'action.buildExport'" class="button is-dark" @click="showExport(true)" />
		<button
			v-if="shareApiSupport"
			v-t="'action.buildShare'"
			class="button is-dark"
			@click="share" />
	</div>
</template>

<script>
import { mapActions } from 'vuex';

const shareApiSupport = navigator.share !== undefined;

export default {
	data: () => ({ shareApiSupport }),
	methods: {
		...mapActions(['showImport', 'showExport']),
		async share() {
			navigator.share({
				title: this.$t('title.sharedBuild'),
				url: window.location.href,
			});
		},
	},
};
</script>
